import {Component, computed, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

type KeyNumberEntry = {
    labelKey: 'iackathon.first_key_number' | 'iackathon.second_key_number' | 'iackathon.third_key_number';
    value: string | undefined;
};

@Component({
  selector: 'app-iackathon-step-key-number',
    imports: [
        TranslateModule
    ],
  templateUrl: './iackathon-step-key-number.component.html',
})
export class IackathonStepKeyNumberComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);

    protected keyNumberEntries = computed<KeyNumberEntry[]>(() => {
        const answers = this.state().sdg_theme_step?.top_group_answers;

        return [
            {
                labelKey: 'iackathon.first_key_number',
                value: answers?.first_number,
            },
            {
                labelKey: 'iackathon.second_key_number',
                value: answers?.second_number,
            },
            {
                labelKey: 'iackathon.third_key_number',
                value: answers?.third_number,
            },
        ];
    });
}
